import { Component, Input } from '@angular/core';

@Component({
  selector: 'social-login-button',
  templateUrl: 'social-login-button.html'
})
export class SocialLoginButtonComponent {
  @Input() signIn: boolean;
  @Input() social: string;
  label: string;

  constructor() {}

  ngOnInit() {
    this.label = this.signIn ? 'Sign in' : 'Sign up';
  }
}



// WEBPACK FOOTER //
// ./src/components/icons/social-login-button/social-login-button.ts